<template>
  <div>
    <Header />
    <div
      class="tw-m-4 tw-mt-4 tw-bg-white tw-shadow-lg  tw-text-left tw-rounded tw-px-8 tw-pt-2 tw-pb-8 tw-mb-4"
    >
      <div v-if="project && !loading">
        <p class="tw-mx-4 tw-block tw-mt-8 tw-font-bold tw-text-2xl">
          Project Name: {{ project.name }}
        </p>

        <v-img
          class="white--text align-end"
          height="250px"
          :src="project.file.split(',')[0]"
          lazy-src="https://picsum.photos/id/11/100/60"
        >
        </v-img>
        <br />
        <p class="tw-mx-4 tw-block">
          <strong>Description:</strong> {{ project.description }}
        </p>
        <p class=" tw-px-4"><strong>Address:</strong> {{ project.address }}</p>
        <p class="tw-block tw-px-4">
          <strong>Sector:</strong> {{ project.sector }}
        </p>
        <p class="tw-block tw-px-4">
          <strong>Approved:</strong> {{ project.approved }}
        </p>

        <p class="tw-block tw-px-4">
          <strong>Status:</strong> {{ project.project_type }}
        </p>
        <p class="tw-block tw-px-4">
          <strong>Verification Date:</strong> {{ project.verification_date }}
        </p>

        <p class="tw-block tw-px-4" v-if="project.verification_number">
          <strong>Verification Number:</strong>
          {{ project.verification_number }}
        </p>

        <p class="tw-block tw-px-4" v-if="project.validated_by">
          <strong>Validated by:</strong> {{ project.validated_by }}
        </p>
        <p class="tw-block tw-px-4" v-if="project.approved_by">
          <strong>Approved by:</strong> {{ project.approved_by }}
        </p>

        <p class="tw-block tw-px-4" v-if="project.certification_report">
          <a :href="project.certification_report" target="_blank">View Image</a>
        </p>
        <!-- <p class="tw-block tw-px-4">
        <strong>Posted by:</strong> {{ project.owner_id.firstName }}
        {{ project.owner_id.lastName }}
        {{ project.dateCreated | moment("from", "now") }}
      </p> -->

        <div v-if="project && user" class="inline-flex">
          <div v-if="project.owner_id._id == company._id" class="inline-flex">
            <button
              @click="dialog = true"
              class="tw-block tw-mt-4 lg:tw-inline-block tw-bg-white tw-text-center tw-bg-eko-light tw-text-white tw-rounded tw-font-semibold tw-text-lg md:tw-px-4  lg:tw-mt-0 tw-mr-4 md:tw-py-1 signin"
            >
              Transfer Project
            </button>
          </div>
        </div>

        <vue-element-loading
          v-if="loading"
          :active="loading"
          :is-full-screen="true"
        />
      </div>

      <v-row justify="center">
        <v-dialog v-model="dialog" scrollable max-width="400px">
          <v-card>
            <v-card-title>Transfer Project</v-card-title>
            <v-divider></v-divider>
            <div class="tw-flex tw-flex-wrap tw-px-4 tw-mb-6 tw-mt-8">
              <div class="tw-w-full tw-mb-6 md:tw-mb-0">
                <label
                  class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                  for="tonnage"
                >
                  Enter email of new owner
                </label>
                <input
                  class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none "
                  id="tonnage"
                  type="text"
                  placeholder="e.g Solving Lagos Traffic"
                  v-model="data.email"
                />
              </div>
              <p v-if="errors.email" class="tw-text-xs tw-text-red-500">
                Please enter email
              </p>
            </div>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="dialog = false"
                >Close</v-btn
              >
              <v-btn @click.prevent="transferProject()">Transfer</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Header from "@/components/Shared/Header";

export default {
  components: {
    Header,
  },
  data() {
    return {
      user: {},
      dialog: false,
      errors: {},
      loading: true,
      token: "",
      project: null,
      data: {},
      company: {},
    };
  },

  mounted() {
    this.token = localStorage.getItem("eko-carbon-token");
    this.user = JSON.parse(localStorage.getItem("eko-carbon-user"));
    this.company = JSON.parse(localStorage.getItem("eko-carbon-company"));
    this.getProject();
  },
  methods: {
    getProject() {
      const self = this;
      axios
        .get(`${this.$baseUrl}/project/get/${this.$route.params.id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          this.project = response.data.project;
          self.loading = false;
          self.success = true;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          console.log(error);
        });
    },
    transferProject() {
      this.errors = {};
      this.loading = true;
      const self = this;
      let deny = false;
      if (!this.data.email) {
        this.errors.email = true;
        deny = true;
      }

      if (deny) {
        return;
      }

      this.data.owner_id = this.project.owner_id._id;
      this.data._id = this.project._id;
      axios
        .post(`${this.$baseUrl}/project/transfer`, this.data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          //   this.project = response.data.project;
          console.log(response);
          self.$swal("Success!", "Project Transferred Successfully", "success");
          self.loading = false;
          self.success = true;
          self.dialog = false;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          let err_msg = error.response.data ? error.response.data.message : "An error occured"
          self.$swal("Error!", err_msg, "error");
        });
    },
  },
};
</script>

<style lang="css" scoped>
.add-btn {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 20px;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  font-size: 36px;
}
.my-img {
  width: 50%;
  height: 50%;
  margin: auto;
}
</style>
